import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { LoadingService } from './loading.service';
import {Base64} from 'js-base64';
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  
  public static docCssUrl= '/media/master-data-css/master_iiiidocEOI.css';
  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private loadingService: LoadingService,
    private router: Router
  ) {}
  DATA:any
  setData(data:any){
    this.DATA = data;
  }
  getData(){
    return this.DATA;
  }
  addAuthHeaders() {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${sessionStorage.getItem('access')}`);
    console.log('>>>>>>token',sessionStorage.getItem('access'));
    headers = headers.set('Authorized-By', `${sessionStorage.getItem('user_id')}`);
    return headers;
  }

  private handleError = (error: HttpErrorResponse) => {
    console.error('RAW ERROR:', error);
  
    let detailMessage = this.buildErrorMessage(error);
  
    if (error.status === 401) {
      this.router.navigate(['/login']);
      detailMessage = 'Session expired. Please log in again.';
    }
  
    this.messageService.clear();
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: detailMessage,
    });
  
    return EMPTY;
  };
  

  private buildErrorMessage(error: HttpErrorResponse): string {

    if (error.error instanceof ErrorEvent) {
      return error.error.message || 'A network error occurred. Please try again.';
    }
  
    // Server tak reach hi nahi hua
    if (error.status === 0) {
      return 'Unable to connect to server. Please check your internet or try again later.';
    }
  
    const payload = error.error;

    if (typeof payload === 'string') {

      // 🔍 Check if server returned HTML error page
      if (/<[a-z][\s\S]*>/i.test(payload)) {
        console.error('HTML Error Response:', payload);
        return 'Server encountered an unexpected error. Please try again later.';
      }
  
      return payload || 'An unexpected error occurred.';
    }
  
    // Agar body hi nahi aayi
    if (payload === null || payload === undefined) {
      return error.message || 'An unexpected error occurred.';
    }
  
    // Body string hai (Django ne direct message bheja hai)
    if (typeof payload === 'string') {
      return payload;
    }
  
    // Body object hai (most Django / DRF / custom JSON)
    if (typeof payload === 'object') {
      // Common patterns
      if (typeof (payload as any).detail === 'string') {
        return (payload as any).detail;
      }
  
      if (typeof (payload as any).message === 'string') {
        return (payload as any).message;
      }
  
      if (Array.isArray((payload as any).message)) {
        return (payload as any).message.join('\n');
      }
  
      if ((payload as any).non_field_errors) {
        const msgs = this.flattenErrors((payload as any).non_field_errors);
        if (msgs.length) {
          return msgs.join('\n');
        }
      }
  
      // Django serializer style: {field: ["This field is required."], ...}
      const flatMessages = this.flattenErrors(payload);
      if (flatMessages.length) {
        return flatMessages.join('\n');
      }
    }
  
    // Fallback
    return error.message || 'An unexpected error occurred.';
  }


  private flattenErrors(err: any, parentKey: string = ''): string[] {
    const messages: string[] = [];
  
    // Array case: ["msg1", "msg2"]
    if (Array.isArray(err)) {
      for (const item of err) {
        if (typeof item === 'string') {
          messages.push(parentKey ? `${parentKey}: ${item}` : item);
        } else {
          messages.push(...this.flattenErrors(item, parentKey));
        }
      }
      return messages;
    }
  
    // Object case: {field: [...], non_field_errors: [...]}
    if (err && typeof err === 'object') {
      for (const key of Object.keys(err)) {
        const value = err[key];
  
        // non_field_errors ko label ke bina dikhayenge
        const label =
          key === 'non_field_errors' || key === 'detail' || key === 'message'
            ? ''
            : key;
  
        if (Array.isArray(value)) {
          for (const v of value) {
            if (typeof v === 'string') {
              messages.push(label ? `${label}: ${v}` : v);
            } else {
              messages.push(...this.flattenErrors(v, label));
            }
          }
        } else if (typeof value === 'object') {
          messages.push(...this.flattenErrors(value, label));
        } else if (typeof value === 'string') {
          messages.push(label ? `${label}: ${value}` : value);
        }
      }
      return messages;
    }
  
    // Primitive fallback
    if (typeof err === 'string') {
      messages.push(parentKey ? `${parentKey}: ${err}` : err);
    } else if (err != null) {
      messages.push(String(err));
    }
  
    return messages;
  }
  

  private withLoader<T>(observable: Observable<T>): Observable<T> {
    this.loadingService.show();
    return observable.pipe(
      finalize(() => this.loadingService.hide()),
      catchError(this.handleError)
    );
  }

  loginAPI(url: string, data: object): Observable<any> {
    console.log('data', data, url);
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Authorization: `Bearer ${sessionStorage.getItem('access')}`
    })
    const completeURL = `${environment.APIUrl}${url}`;
    return this.withLoader(this.http.post(completeURL, data,{headers}).pipe(catchError(this.handleError)));
  }

  postAPI(url: string, data: object): Observable<any> {
    const completeURL = `${environment.APIUrl}${url}`;
    // const headers = this.addAuthHeaders();
      let headers = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${sessionStorage.getItem('access')}`);
    headers = headers.set('Authorized-By', `${sessionStorage.getItem('user_id')}`);
    return this.withLoader(this.http.post(completeURL, data, { headers }).pipe(catchError(this.handleError)));
  }

  getAPI(url: string): Observable<any> {
    const completeURL = `${environment.APIUrl}${url}`;
    // const headers = this.addAuthHeaders();
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${sessionStorage.getItem('access')}`);
    headers = headers.set('Authorized-By', `${sessionStorage.getItem('user_id')}`);
    return this.withLoader(this.http.get(completeURL, { headers }).pipe(catchError(this.handleError)));
  }

  putAPI(url: string, data: object): Observable<any> {
    const completeURL = `${environment.APIUrl}${url}`;
    // const headers = this.addAuthHeaders();
      let headers = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${sessionStorage.getItem('access')}`);
    headers = headers.set('Authorized-By', `${sessionStorage.getItem('user_id')}`);
    return this.withLoader(this.http.put(completeURL, data, { headers }).pipe(catchError(this.handleError)));
  }

  patchAPI(url: string, data: object): Observable<any> {
    const completeURL = `${environment.APIUrl}${url}`;
    // const headers = this.addAuthHeaders();
      let headers = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${sessionStorage.getItem('access')}`);
    headers = headers.set('Authorized-By', `${sessionStorage.getItem('user_id')}`);
    return this.withLoader(this.http.patch(completeURL, data, { headers }).pipe(catchError(this.handleError)));
  }

  deleteAPI(url: string): Observable<any> {
    const completeURL = `${environment.APIUrl}${url}`;
    // const headers = this.addAuthHeaders();
      let headers = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${sessionStorage.getItem('access')}`);
    headers = headers.set('Authorized-By', `${sessionStorage.getItem('user_id')}`);
    return this.withLoader(this.http.delete(completeURL, { headers }).pipe(catchError(this.handleError)));
  }
       encrypt(str, secret) {
        // Add random string to the start of the input string
        str = Math.random().toString(36).substring(2, 10) + str;

        // Decode the secret key
        const decodedSecret = atob(secret);
        const [ivString, keyString] = decodedSecret.split(',');

        // Parse the IV and Key
        const IV = CryptoJS.enc.Base64.parse(ivString);
        const Key = CryptoJS.enc.Base64.parse(keyString);

        // Encrypt the text
        const text = CryptoJS.enc.Utf8.parse(str);
        const encryptedText = CryptoJS.AES.encrypt(text, Key, {
            iv: IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        // Convert the encrypted text to Base64 and then to Hex
        const b64 = encryptedText.toString();
        const e64 = CryptoJS.enc.Base64.parse(b64);
        const eHex = e64.toString(CryptoJS.enc.Hex);

        // Return the encrypted text in uppercase
        return eHex.toUpperCase();
        }


    decrypt(str, secret) {
        try {
            var _strkey = Base64.decode(secret);
            var reb64 = CryptoJS.enc.Hex.parse(str);
            var text = reb64.toString(CryptoJS.enc.Base64);
            var Key = CryptoJS.enc.Base64.parse(_strkey.split(',')[1]); //secret key
            var IV = CryptoJS.enc.Base64.parse(_strkey.split(',')[0]); //16 digit
            var decryptedText = CryptoJS.AES.decrypt(text, Key, {
                keySize: 128 / 8,
                iv: IV,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            return decryptedText.toString(CryptoJS.enc.Utf8); //binascii.unhexlify(decryptedText)
        } catch (e) {
        
        }
    }
// refreshToken(url: string) {
//    const completeURL = `${environment.APIUrl}${url}`;
//     // const headers = this.addAuthHeaders();
//       let headers = new HttpHeaders();
//     headers = headers.set('Authorization', `Bearer ${sessionStorage.getItem('access')}`);
//     headers = headers.set('Authorized-By', `${sessionStorage.getItem('user_id')}`);
//     // return this.withLoader(this.http.get(completeURL, { headers }).pipe(catchError(this.handleError)));
//   return this.http.get<any>(completeURL).pipe(
//     catchError(this.handleError) // Handle errors here if necessary
//   );
// }
isLoggedIn(): boolean {
  return !!sessionStorage.getItem('access') && this.getUserId() != null;
}
getUserId():boolean{
   return !!sessionStorage.getItem('user_id');
}
}
